.alert {
    margin: var(--bi-scale-6x) auto 0;
    max-width: 552px;
    font: var(--bi-font-body-large);
}
